// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label[data-v-56a2261e]{background-color:var(--outline-color)!important}label[data-v-56a2261e]:after{background-color:var(--switch-color)!important}", ""]);
// Exports
module.exports = exports;
